import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export const uploadDonors = async (formData, nonprofitId) => {
	try {
		const config = {
			headers: {
				'Authorization': `Bearer ${localStorage.getItem('accessToken')}`
			}
		}
		const response = await axios.post(`${API_URL}/nonprofits/${nonprofitId}/upload_donors/`, formData, config);
		return response.data;
	} catch (error) {
		if (error.response && error.response.status === 500) {
      		console.error("500 Internal Server Error");
			throw error;
    	} else {
			console.error("Donor Upload error:", error.response);
			throw error;
		}
	}
};
